// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"nft-image-loading_Wrapper__MHsfL","SpinnerWrapper":"nft-image-loading_SpinnerWrapper__0AI6D"};